import request from '@/utils/request'

let HeadframeApi = {
  /*列表*/
  labelList(data, errorback) {
    return request._get('/shop/label.label/index', data, errorback);
  },
  getAlllabelList(data, errorback) {
    return request._get('/shop/label.label/getAll', data, errorback);
  },
  /*列表详情*/
  labelDetail(data, errorback) {
    return request._get('/shop/label.label/detail', data, errorback);
  },
  /*添加*/
  labelAdd(data, errorback) {
    return request._post('/shop/label.label/add', data, errorback);
  },
  /*修改*/
  updatelabel(data, errorback) {
    return request._post('/shop/label.label/edit', data, errorback);
  },
  /*删除*/
  labeldelete(data, errorback) {
    return request._post('/shop/label.label/delete', data, errorback);
  },
  /*是否显示音乐*/
  labelshow(data, errorback) {
    return request._post('/shop/label.label/editStatus', data, errorback);
  },

}
export default HeadframeApi;



// WEBPACK FOOTER //
// ./src/api/headframe.js